import { h, ComponentType, RefObject, JSX } from "preact";

import Link from "../../../../foundation/router/Link";
import classname from "../../../../foundation/utils/classname";
import IconProps from "../../../Icons/IconProps";

import styles from "./TabButton.module.css";

type NativeButtonProps = Omit<JSX.HTMLAttributes<HTMLButtonElement>, "icon" | "children">;

interface ExtendedIconProps extends IconProps {
    backgroundColor?: string;
}

interface Props extends NativeButtonProps{
    label?: string;
    icon?: ComponentType<IconProps>;
    iconProps?: Partial<ExtendedIconProps>;
    shortcut?: string;
    to?: string;
    selected?: boolean;
    buttonRef?: RefObject<HTMLButtonElement>;
}

function TabButton({
    class: cssClass,
    label,
    icon: Icon,
    iconProps,
    shortcut,
    to = "",
    selected,
    buttonRef,
    ...nativeButtonProps
}: Props) {
    const hasShortcut = !!shortcut;

    return (
        <Link to={to}>
            <button
                {...nativeButtonProps}
                class={classname("caption-1 medium noSelect", styles.tabButton, cssClass, {
                    [styles.selected]: selected,
                    [styles.hasShortcut]: hasShortcut
                })}
                ref={buttonRef}>
                {Icon && (
                    <div class={styles.icon}>
                        <Icon {...iconProps}/>
                    </div>
                )}
                <span class={styles.content}>{label}</span>
                {shortcut && <span class={styles.shortcut}>{shortcut}</span>}
            </button>
        </Link>
    );
}

export default TabButton;
